import { useEffect } from 'react';
import useAuth from 'hooks/useAuth';
import useNotificationsStore from './notificationsStore';
import { useApiFetcher } from 'utils/fetcher/ApiFetcher';

const POLL_INTERVAL_MS = 120000;

// Same roles allowed to see the notifications badge.
const AUTHORIZED_ROLES = [1, 100, 110];

/**
 * useNotificationsPoller — Component-independent polling hook.
 * Mount once in DashboardLayout. Activates for authenticated users with an
 * authorized role (the endpoint also validates privilege 0100).
 * Polls GetUnreadCount every 120s and updates the store's unreadCount.
 */
const useNotificationsPoller = () => {
  const { user, ValidateRole } = useAuth();
  const apiFetcher = useApiFetcher();
  const fetchUnreadCount = useNotificationsStore(state => state.fetchUnreadCount);

  const isAuthorized = user?.id && ValidateRole(user?.role, AUTHORIZED_ROLES) === true;

  useEffect(() => {
    if (!isAuthorized) return;

    fetchUnreadCount(apiFetcher);

    const intervalId = setInterval(() => {
      fetchUnreadCount(apiFetcher);
    }, POLL_INTERVAL_MS);

    return () => clearInterval(intervalId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id, isAuthorized]);
};

export default useNotificationsPoller;
